import React from 'react';
export function AppendixDividerSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-88">
      <div className="flex flex-col items-center justify-center w-full h-full text-center px-4" data-id="element-89">
        <p className="italic font-semibold mb-[clamp(1rem,2vw,1.5rem)] animate-fade-slide" style={{
        color: '#4A90D9',
        fontSize: 'var(--h2-size)',
        animationDelay: '0.1s'
      }} data-id="element-90">
          Appendix
        </p>
        <h1 className="font-black tracking-tight text-white leading-[1.1] animate-fade-slide" style={{
        fontSize: 'calc(var(--title-size) * 1.2)',
        animationDelay: '0.2s'
      }} data-id="element-91">
          Engineering
          <br data-id="element-92" />
          Experimentation
        </h1>
        <div className="mt-[clamp(1.5rem,3vw,2.5rem)] animate-fade-slide" style={{
        width: 'clamp(60px, 8vw, 100px)',
        height: '4px',
        backgroundColor: '#4A90D9',
        animationDelay: '0.3s'
      }} data-id="element-93" />
      </div>
    </section>;
}